import React from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';

const PartnerItem = (props) => {
    const { title, image, description } = props;

    return (
        /* eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex */
        <div tabIndex="0" className="contentPartner">
            <figure>
                <img alt={`Logo: ${title}`} src={image} />
            </figure>
            {/* eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex */}
            <h4>
                {title}
            </h4>
            <p className="contentTx">
                {description}
            </p>
        </div>
    );
};

PartnerItem.propTypes = exact({
    title: PropTypes.string.isRequired,
    image: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
});

export default PartnerItem;
